import { render } from "./CategorySelectComponent.vue?vue&type=template&id=0a024a1f&scoped=true&ts=true"
import script from "./CategorySelectComponent.vue?vue&type=script&lang=ts"
export * from "./CategorySelectComponent.vue?vue&type=script&lang=ts"

import "./CategorySelectComponent.vue?vue&type=style&index=0&id=0a024a1f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2333909795/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a024a1f"]])

export default __exports__